/* global Excel */

//Utilties for macros

/**
 * Applies borders to the specified edges of a given Excel range.
 *
 * @param {Excel.Range} range - The Excel range to apply borders to.
 * @param {Excel.BorderIndex[]} [edges] - An array of border edges to apply.
 *   Defaults to all four edges: top, bottom, left, and right.
 * @param {Excel.BorderLineStyle} [style] - The border style to apply (e.g., continuous, dash, dot).
 *   Defaults to continuous.
 * @param {Excel.BorderWeight} [weight] - The thickness of the border (e.g., thin, medium, thick).
 *   Defaults to thin.
 * @param {string} [color] - The color of the border. Defaults to black.
 *
 * @example
 * // Apply a medium red border to the top and bottom of a range:
 * applyBorders(range, [Excel.BorderIndex.edgeTop, Excel.BorderIndex.edgeBottom], Excel.BorderLineStyle.continuous, Excel.BorderWeight.medium, "red");
 */
export function applyBorders(
  range: Excel.Range,
  edges: Excel.BorderIndex[] = [
    Excel.BorderIndex.edgeTop,
    Excel.BorderIndex.edgeBottom,
    Excel.BorderIndex.edgeLeft,
    Excel.BorderIndex.edgeRight,
  ],
  style: Excel.BorderLineStyle = Excel.BorderLineStyle.continuous,
  weight: Excel.BorderWeight = Excel.BorderWeight.thin,
  color: string = "black"
) {
  edges.forEach((edge) => {
    const border = range.format.borders.getItem(edge);
    border.style = style;
    border.weight = weight;
    border.color = color;
  });
}
